import { render, staticRenderFns } from "./ActRelatedTemplate.vue?vue&type=template&id=70af8206&"
import script from "./ActRelatedTemplate.vue?vue&type=script&lang=js&"
export * from "./ActRelatedTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports